import { router } from './router';
import { store } from '../_store';
import * as process from "process";

export function authHeaders(additionalHeaders) {
  // return authorization header with jwt token
  let user = JSON.parse(localStorage.getItem('user'));
  let res = {};
  if (user && user.token) {
    res = { Authorization: 'Bearer ' + user.token };
  } else if (process.env.API_TOKEN) {
    res = { Authorization: 'Token ' + process.env.API_TOKEN };
  }

  if (additionalHeaders) {
    res = Object.assign(additionalHeaders, res);
  }

  return res;
}

export function processApiError(error,route) {
  if (error.response && error.response.status === 401) {
    if (route) {
      router.push(route);
    } else {
      router.push('/login');
    }
    return;
  }

  let additionalInfo = '';

  if (error.response && error.response.data) {
    const err = error.response.data;
    if (err.msg) {
      additionalInfo = err.msg;
    } else if (err.message) {
      additionalInfo = err.message;
    }
    additionalInfo = additionalInfo ? ' (' + additionalInfo + ')' : '';
  }
  const errorMessage =
    error.message || error.error || error.statusText || error;

  store.dispatch('alert/error', errorMessage + additionalInfo, { root: true });
}
